export const Bio = {
  name: "Mohammad Saify Sheikh",
  roles: [
    "Software Engineer",
    "Programmer",
    "Full Stack Developer",
    "ML Engineer",
  ],
  description:
    "I am a motivated and adaptable person who loves taking on new challenges. I enjoy learning and always strive to deliver great results. With a positive attitude and a growth mindset, I am ready to contribute and achieve great things.",
  github: "https://github.com/SaifySheikh",
  resume:
    "https://drive.google.com/file/d/18K4ydU0uf-p6wD2nNf8p5jKMDVQvjG7O/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/saify-sheikh/",
  twitter: "https://x.com/Saify_Sheikh_1",
  insta: "https://www.instagram.com/saify_sheikh_1/",
};

export const skills = [
  {
    title: "Web Development",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Programing & Tools",
    skills: [
      {
        name: "C",
        image:
          "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/C.png?alt=media&token=e650d3aa-d79c-47d7-964b-752b6d612590",
      },
      {
        name: "C++",
        image:
          "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/C%2B%2B.png?alt=media&token=a9575545-cb1d-4eba-90ed-78edd62f96c7",
      },
      {
        name: "Python",
        image:
          "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/python.png?alt=media&token=c0ec1a07-b4e4-40cb-ad1c-3c553235731b",
      },
      {
        name: "GitHub",
        image:
        "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Vercal",
        image:
          "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/vercal.jpg?alt=media&token=4df8f175-d4db-4c98-9aab-ead94161269e",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/postman.png?alt=media&token=fbae0c2a-6695-4268-bffe-a81f356bbbf4",
      },
      {
        name: "Figma",
        image:
          "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/figma.png?alt=media&token=804c5ae2-63d6-4634-8ee5-e63ff3eeae54",
      },
      {
        name: "Tensorflow",
        image:
          "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/tensorflow.webp?alt=media&token=80a8f4eb-b4d0-4430-8b9f-e26b1031a7c1",
      },
    ],
  },
  {
    title: "Core Subjects",
    skills: [
      {
        name: "Data Structure and Algorithm",
        image: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/DSA.jpg?alt=media&token=1ecc73c7-0ef2-44fd-aecd-b10962d585d4",
      },
      {
        name: "Design and Analysis of Algorithm",
        image: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/DAA.jpg?alt=media&token=729d312e-bd70-4823-a57c-3fe173e7ef1b",
      },
      {
        name: "Database and Management System",
        image: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/DBMS.jpg?alt=media&token=122777ad-a210-4e1d-9254-d94e4fafc9aa",
      },
      {
        name: "Operating System",
        image: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/OS.webp?alt=media&token=709e3cf2-9f33-4f25-aecb-b95f60fdd289",
      },
      {
        name: "Computer Network",
        image: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/CN.png?alt=media&token=7767b533-64c4-4569-9430-3654f1adaef1",
      },
      {
        name: "Object Oriented Programming",
        image: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/oops.jpg?alt=media&token=415d4b80-e146-47ea-a8c6-34107625685d",
      },
    ],
  },
  {
    title: "Competitive Programming Profiles",
    skills: [
      {
        name: "Codechef",
        image:
        "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/code%20chef.png?alt=media&token=564fced3-a524-45ae-ad1e-3184bdb316d5",
        link: "https://www.codechef.com/users/saifysheikh",
      },
        
      {
        name: "Leetcode",
        image:
          "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Leetcode.png?alt=media&token=f773f543-8d47-4efe-9438-efc3008854f9",
        link: "https://leetcode.com/saifyssk04/",
        },
      {
        name: "Coding Ninjas",
        image:
          "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/coding%20ninjas.jpg?alt=media&token=6d7b4f75-2312-4ee2-923f-574d7138c832",
        link: "https://www.naukri.com/code360/profile/SaifySheikh",
      },
      
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Anamta%20Outsourcing.png?alt=media&token=4244eb22-c615-4b1a-9945-2973587faa52",
    role: "Fullstack Engineering Intern",
    company: "Anamta Outsourcing Pvt. Ltd.",
    date: "Jan 2024 - March 2024",
    desc: "Built an end to end employee management system- Nayarecruiter. The website comprised of all the essential components for recruiters to manage their employees and the workload.",
    skills: [
      "HTML",
      "CSS",
      "Javascript",
      "EmailJs",
      "MongoDB",
      "Node Js",
      "Express Js",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Mohammad%20Saify%20Sheikh%20Internship%20Certificate_page-0001.jpg?alt=media&token=0e2ac62b-d203-488b-89b3-f4bf8517f5d2",
  },
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Bharat%20Intern.jpg?alt=media&token=0d61d625-0110-4073-8aa8-2268927a4081",
    role: "Frontend Engineer Intern",
    company: "Bharat Intern",
    date: "Oct 2023 - Nov 2023",
    desc: "Working on the frontend of the web application using HTML, CSS and Javascript.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Tailwind CSS",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Bharat%20intern%20internship%20certificate.jpg?alt=media&token=b4a6d83d-fd6f-4938-87e2-dce4fa5cc210",
  },
  
];

export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Rcoemimg.png?alt=media&token=81bdc4c1-8070-4959-9516-c6a3ab287cf6",
    school: "Shri Ramdeobaba College of Engineering and Management, Nagpur",
    date: "Oct 2021 - Sep 2025",
    grade: "9.56 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Shri Ramdeobaba College of Engineering and Management, Nagpur. I have completed 6 semesters and have a CGPA of 9.56. I have Studied about different subjects like Data Structures and Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
    school: "Jai Hind Junoiur College of Science, Chandrapur",
    date: "Jun 2019 - Jun 2021",
    grade: "92.5%",
    desc: "I completed my class 12 high school education at Jai Hind Junoiur College of Science, Chandrapur, where I studied Science with Computer Science.",
    degree: "HSC(XII), Computer Science",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/DilasagramImage.jpg?alt=media&token=dcd2ef4a-a611-4097-9219-4f0d6727fb8a",
    school: "Dilasagram Convent High School, Ballarpur",
    date: "Apr 2017 - Apr 2019",
    grade: "87.4%",
    desc: "I completed my class 10th education at Dilasagram Convent High School, Ballarpur, where I Completed my Education till 10th Standard.",
    degree: "HSC(X), 10th",
  },
];

export const projects = [
  {
    id: 9,
    title: "Portfolio",
    date: "April 2024 - May 2024",
    description:
      "This is My Portfolio Website showcasing my Projects, Education, Experience and skills that i gained by Learning.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Portfolio%20website.png?alt=media&token=df9ae53a-baaf-44de-ab60-4f06fbe8cbc7",
    tags: [
      "HTML",
      "CSS",
      "Javascript",
      "React Js",
      "Material UI",
    ],
    category: "web app",
    github: "https://github.com/SaifySheikh/SaifySheikh-Portfolio",
    webapp: "https://main--ssk-portfolio.netlify.app/",
  },
  
  {
    id: 1,
    title: "NayaRecruiter - Employee Management System",
    date: "Jan 2024 - Mar 2024",
    description:
      "Built an end to end employee management system- Nayarecruiter.The website comprised of all the essential components for recruiters to manage their employees and the workload",
    image:
      "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/NayaRecruiter.png?alt=media&token=9977aba1-55c9-47d7-812c-21b0e3762a2c",
    tags: [
      "HTML",
      "CSS",
      "Javascript",
      "EmailJs",
      "MongoDb",
      "Node Js",
      "Express Js",
    ],
    category: "web app",
    github: "https://github.com/SaifySheikh/EMS_New_Repo_with_Email",
    webapp: "https://github.com/SaifySheikh/EMS_New_Repo_with_Email",
  },
  {
    id: 10,
    title: "Notes App",
    date: "Nov 2023 - Dec 2023",
    description:
      "Notable app is an android application for maintaining personal notes and can also share with others.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Noteable.png?alt=media&token=c65c72c2-ef66-4adb-9a4d-b096391629ad",
    tags: ["Android Studio", "Java", "Firebase","Figma"],
    category: "android app",
    github: "https://github.com/SaifySheikh/Noteable-app",
    webapp: "https://github.com/SaifySheikh/Noteable-app",
    member: [
      {
        name: "Mohammad Saify Sheikh",
        img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Saifyimg.jpeg?alt=media&token=514633bd-3e69-414a-ab79-cb2e66c03905",
        linkedin: "https://www.linkedin.com/in/saify-sheikh/",
        github: "https://github.com/SaifySheikh",
      },
      {
        name: "Himanshu Sharma",
        img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/men.jpg?alt=media&token=e76089e4-e493-4754-8a8d-6eef3d440b2a",
        linkedin: "https://www.linkedin.com/in/himanshu-sharma-dev/",
        github: "https://www.linkedin.com/in/himanshu-sharma-dev/",
      },
    ],
  },
   {
    id: 5,
    title: "Manzar Website",
    date: "Aug 2023 - Sep 2023",
    description:
      " Made a college website for an event named Manzar. We won the first prize for it.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Manzar%20Website.png?alt=media&token=d15cef06-6ae7-4ad3-a43a-37b564832603",
    tags: ["React Js", "HTML", "CSS","Figma"],
    category: "web app",
    github: "https://github.com/SaifySheikh/ManzarWebsite",
    webapp: "https://csebmanzar.netlify.app/",
    member: [
      {
        name: "Mohammad Saify Sheikh",
        img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/Saifyimg.jpeg?alt=media&token=514633bd-3e69-414a-ab79-cb2e66c03905",
        linkedin: "https://www.linkedin.com/in/saify-sheikh/",
        github: "https://github.com/SaifySheikh",
      },
      {
        name: "Sujal Agrawal",
        img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/sujalmember.jpg?alt=media&token=ef6b3946-9864-42c9-aed2-7eb1dc453ada",
        linkedin: "https://www.linkedin.com/in/sujal-agrawal-655781230/",
        github: "https://github.com/sujal1885",
      },
      {
        name: "Vivek Meher",
        img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/vivek.png?alt=media&token=89f2615f-cebd-4ed4-a6f7-58e7f62977ce",
        linkedin: "https://www.linkedin.com/in/vivek-meher-a19566272/",
        github: "https://github.com/vivek9545",
      },
      {
        name: "Milind Dadore",
        img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/MilindMember.jpg?alt=media&token=57ad2a7b-9913-4d32-a327-1aab9df01484",
        linkedin: "https://www.linkedin.com/in/milind-dadore/",
        github: "https://github.com/Milind2401",
      },
      {
        name: "Godwin Shalom",
        img: "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/GodwinMember.jpg?alt=media&token=dfa5627b-a55d-4c29-bd53-216e9f1305a9",
        linkedin: "https://www.linkedin.com/in/godwin410/",
        github: "https://www.linkedin.com/in/godwin410/",
      },
    ],
  },
  {
    id: 6,
    title: "PasswordX",
    date: "July 2023 - Aug 2023",
    description:
      "Tired of forgetting your login credentials? PasswordX simplifies your digital life by providing a user-friendly platform to store and organize your usernames and passwords securely.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/PasswordX.png?alt=media&token=d1c45227-b06c-4e15-bae7-ed9ff6f376b8",
    tags: ["HTML", "CSS", "Javascript","Local Storage"],
    category: "web app",
    github: "https://github.com/SaifySheikh/PasswordX",
    webapp: "https://password-x.vercel.app/",
  },
  {
    id: 8,
    title: "Sign Language to Text and Audio Conversion",
    date: "Jan 2024 - April 2024",
    description:
      "A Sign Language to Text and Audio Conversion app which uses OpenCV. It is made with Tensorflow, the dataset which we had use is also made by us.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/dilasaimg.appspot.com/o/sign%20Language%20Recognition.png?alt=media&token=7dbad335-4ce4-4081-b1cc-c01cbdf2cc65",
    tags: ["Python", "Keras", "TensorFlow", "CNN", "Flask","MongoDB","Scikit Learn"],
    category: "machine learning",
    github: "https://github.com/SaifySheikh/Sign_Recognition_Project",
    webapp: "https://github.com/SaifySheikh/Sign_Recognition_Project",
  },
];

export const TimeLineData = [
  { year: 2021, text: "Worked on Understanding CS Fundamentals" },
  { year: 2022, text: "Worked On Programming Skills" },
  { year: 2023, text: "Worked on Web Development Skills" },
  { year: 2024, text: "Worked on Core Subjects and Overall Skills" },
];
